import { render, staticRenderFns } from "./TrainingEventFlyerModal.vue?vue&type=template&id=452e05e2&scoped=true"
import script from "./TrainingEventFlyerModal.vue?vue&type=script&lang=js"
export * from "./TrainingEventFlyerModal.vue?vue&type=script&lang=js"
import style0 from "./TrainingEventFlyerModal.vue?vue&type=style&index=0&id=452e05e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452e05e2",
  null
  
)

export default component.exports